//import useGlobalStore from "@/stores/global.store";
import { useQuery } from '@tanstack/react-query';
import { SalesRound } from '@/types/api/sale';
import api from '@/api';

type SalesRoundsQueryKey = ['sales-rounds'];

export function useSalesRoundsQuery() {
  return useQuery<SalesRound[], Error, SalesRound[], SalesRoundsQueryKey>({
    queryKey: ['sales-rounds'],
    queryFn: () => api.sale.rounds.list(),
  });
}
